(function () {
  class SymbolAnimator extends PIXI.Container {
    constructor() {
      super();
      this._movies = []; // currently playing movies
      this._movieData = {};
      this._completeCb = undefined;
      this._removeFromSceneAfterUse = false;
    }

    // for each symbol we store a pool for this type and also its type so it can be instantiated when pool is empty
    initialiseMoviePool(symbolMovies) {
      for (let prop in symbolMovies) {
        if (symbolMovies.hasOwnProperty(prop)) {
          let data = symbolMovies[prop];
          this._movieData[prop] = {
            pool: {},
            type: data.type,
            numInstantiated: 0,
            playData: data.playData,
          };
        }
      }
    }

    // get a movie file from the pool of movies. Reserved space is how much cells the symbol takes up, think gigablox and megaways
    getSymbolAnimation(symbolId, reservedSpace) {
      let movie = undefined;

      let data = this._movieData["" + symbolId];
      // are there any movies in the pool we can use?
      if (
        data.pool["" + reservedSpace] &&
        data.pool["" + reservedSpace].length > 0
      ) {
        movie = data.pool["" + reservedSpace].pop();
        if (this._removeFromSceneAfterUse) {
          movie.origParent.addChild(movie);
        }
      } else {
        // no movies left in pool, create a new one

        movie = resourceManager.createObject(
          data.type,
          "symbolAnim_" + symbolId + "_" + data.numInstantiated,
          this.name,
          { playData: data.playData }
        );
        ++data.numInstantiated;
      }
      return movie;
    }

    onSymbolTracked(loop, onCellAnimFinishedCb, trackInfo) {
      let movie = this.getSymbolAnimation(
        trackInfo.symbolId,
        trackInfo.reservedSpace
      );
      movie.play(trackInfo, loop, onCellAnimFinishedCb);
      this._movies.push(movie);
    }

    invokeCompleteCallback() {
      if (this._completeCb) {
        let cb = this._completeCb;
        this._completeCb = undefined;
        cb();
      }
    }

    onSymbolUntracked(trackInfo) {
      for (let i = 0; i < this._movies.length; ++i) {
        let movie = this._movies[i];
        let movieTrackInfo = movie.getTrackInfo();
        if (
          movieTrackInfo.uniqueSymbolId === trackInfo.uniqueSymbolId &&
          movieTrackInfo.reelId === trackInfo.reelId
        ) {
          let data = this._movieData[movieTrackInfo.symbolId];
          if (data.pool["" + trackInfo.reservedSpace] === undefined)
            data.pool["" + trackInfo.reservedSpace] = [];

          data.pool["" + trackInfo.reservedSpace].push(movie);
          this._movies.splice(i, 1);
          movie.finalise();
          movie.origParent = movie.parent;
          if (this._removeFromSceneAfterUse) {
            movie.parent.removeChild(movie);
          }
          break;
        }
      }

      if (this._movies.length === 0) {
        // All animations complete, so call complete callback
        this.invokeCompleteCallback();
      }
    }

    skip() {
      while (this._movies.length > 0) {
        // dont replace with for loop as skipping removes elements from the movies array so it will skip elements as its size changes.
        this._movies[0].skip();
      }
      this.invokeCompleteCallback();
    }

    trackAllWinningSymbols(symbols, slotMachine, loop) {
      let onCellAnimFinishedCb = function (who) {
        who.untrack();
      };
      for (let i = 0; i < symbols.length; ++i) {
        let data = symbols[i];
        slotMachine.trackSymbolInWindow(
          data.cell.reel,
          data.cell.row,
          data.symbolId,
          this.onSymbolTracked.bind(this, loop, onCellAnimFinishedCb),
          this.onSymbolUntracked.bind(this)
        );
      }
    }

    animateSymbols(symbols, slotMachine, canCelebreate, loop, callback) {
      if (canCelebreate) {
        this._completeCb = callback;
        this.trackAllWinningSymbols(symbols, slotMachine, loop);
      } else {
        callback();
      }
    }
  }

  let create = function () {
    return new SymbolAnimator();
  };

  let initialise = function (json, instance) {
    instance._removeFromSceneAfterUse = !!json.removeFromSceneAfterUse;
    instance.initialiseMoviePool(json.symbolMovies);
  };

  let getRequiredFiles = function (json) {
    let allFiles = [];
    let keys = Object.keys(json.symbolMovies);
    let foundKeys = {};
    let indexes = [];
    for (let i = 0; i < keys.length; ++i) {
      let type = json.symbolMovies[keys[i]].type;
      if (foundKeys[type] === undefined) {
        foundKeys[type] = true;
        if (resourceManager.filesRequiredFunctions[type]) {
          let files = resourceManager.filesRequiredFunctions[type]();
          if (Array.isArray(files)) {
            allFiles = allFiles.concat(files);
          }
        }
      }
    }
    return allFiles;
  };

  resourceManager.registerObjectType(
    "SymbolAnimatorEx",
    create,
    initialise,
    getRequiredFiles
  );
})();
